import { useModal } from '@ebay/nice-modal-react'
import { Link } from '@tanstack/router'
import { type CSSProperties, useEffect, useMemo, useState } from 'react'

import useDimensions from '../../hooks/useDimensions'
import type { AnnouncementObj } from '../../types/announcement'
import type { ApiResponse } from '../../types/api'
import { api } from '../../utils/api-client'
import Icon from '../icon'
import AllAnnouncementsModal from './all-announcements-modal'

interface AnnouncementCarouselProps {
  containerStyle?: CSSProperties
}

const AnnouncementCarousel = ({
  containerStyle,
}: AnnouncementCarouselProps) => {
  const allAnouncementsModal = useModal(AllAnnouncementsModal)
  const { isDesktop } = useDimensions()
  const [announcements, setAnnouncements] = useState<AnnouncementObj[]>([])

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await api.post<ApiResponse<AnnouncementObj[]>>(
          '/ajax_check.php',
          { type: 'get_notice', num: 10 },
        )
        const { status, info } = response.data
        if (status === 1) {
          setAnnouncements(info)
        }
      } catch (error) {
        console.error(error)
      }
    }
    fetchAnnouncements()
  }, [])

  const joinedAnnouncements = announcements
    .map(item => item.content)
    .join('         ') // Extra space for separation

  const animationDuration = useMemo(() => {
    let duration =
      joinedAnnouncements.length *
      (isDesktop && joinedAnnouncements.length <= 180 ? 0.5 : 0.2)
    if (duration < 5 && !isDesktop) {
      duration = 10
    }
    if (duration < 20 && isDesktop) {
      duration = 30
    }
    return duration
  }, [joinedAnnouncements, isDesktop])

  if (announcements.length === 0) return null

  return (
    <Link to={isDesktop ? undefined : '/announcements'}>
      <span
        onClick={isDesktop ? () => allAnouncementsModal.show() : undefined}
        style={containerStyle}
        className="flx-str-ctr w-full z-[99] px-3 py-0 xl:pt-2.5 xl:pb-0 xl:px-[90px] 3xl:px-[150px] 3xl:py-2.5 4xl:px-[250px] 4xl:py-2.5">
        <Icon id="bell-news" width={16} height={16}></Icon>
        <div className="flex-1 overflow-hidden">
          <p
            className="uppercase text-sm animate-animation whitespace-nowrap text-highlight xl:text-base"
            style={{
              animationDuration: `${animationDuration}s`,
            }}>
            {joinedAnnouncements}
          </p>
        </div>
      </span>
    </Link>
  )
}

export default AnnouncementCarousel
